(() => {
  const marker = document.querySelector('[data-fp-pdp-arm]');
  const scope = marker?.closest('.shop-product-section');
  const arm = marker?.dataset.fpPdpArm;
  if (!scope || !['control','challenger'].includes(arm)) return;
  const form = scope.querySelector('product-form form');
  if (!form || form.dataset.fpPdpTestBound) return;
  form.dataset.fpPdpTestBound = arm;
  const environment = window.Shopify?.theme?.role === 'main' ? 'live' : 'preview';
  const journey = Array.from(crypto.getRandomValues(new Uint8Array(12)), n => n.toString(16).padStart(2,'0')).join('');
  const selector = scope.querySelector('fourpaw-package-selector');
  const stages = {};
  let submitted = [];
  const track = (action, accessory, extra = {}) => {
    const stage = stages[accessory] ||= {};
    if (action === 'viewed') stage.viewed = true;
    if (action === 'details_opened') stage.details = true;
    if (action === 'selected') stage.source = 'card';
    const tracked = window.FourPawAnalytics?.publish('fourpaw:upsell_interaction',{action,accessory,slot:accessory === 'collar' ? 2 : 1,journey,...extra});
    const card = selector?.querySelector(`[data-package-addon="${accessory}"]`);
    if (tracked && card) card.dataset.fpLastTrackedAction = action;
  };
  if (arm === 'control' && selector) {
    selector.addEventListener('change', event => {
      if (!event.target.matches('[data-package-input]')) return;
      const accessory = event.target.closest('[data-package-addon]')?.dataset.packageAddon;
      if (['bungee','collar'].includes(accessory)) track(event.target.checked ? 'selected' : 'deselected',accessory,{source:'card'});
    });
    selector.addEventListener('click', event => {
      const accessory = event.target.closest('[data-package-info-button]')?.dataset.packageInfoButton;
      if (['bungee','collar'].includes(accessory)) track('details_opened',accessory,{source:'details'});
    });
    selector.querySelector('dialog')?.addEventListener('close', event => {
      const accessory = event.currentTarget.dataset.packageAddon;
      if (['bungee','collar'].includes(accessory)) track('details_closed',accessory,{source:'details'});
    });
    if ('IntersectionObserver' in window) {
      const exposed = new Set(), timers = new Map();
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        const accessory = entry.target.dataset.packageAddon;
        if (!entry.isIntersecting || entry.intersectionRatio < .5) { clearTimeout(timers.get(accessory)); timers.delete(accessory); return; }
        if (exposed.has(accessory) || timers.has(accessory)) return;
        timers.set(accessory,setTimeout(() => {
          timers.delete(accessory);
          if (!selector.isConnected || document.visibilityState === 'hidden') return;
          exposed.add(accessory); track('viewed',accessory);
        },1000));
      }),{threshold:[0,.5]});
      selector.querySelectorAll('[data-package-card]').forEach(card => observer.observe(card));
    }
    scope.addEventListener('fourpaw:product-form:add-to-cart-succeeded', () => submitted.forEach(accessory => track('cart_added',accessory)));
  }
  form.addEventListener('fourpaw:product-form-data', event => {
    const data = event.detail?.formData;
    if (!data) return;
    const evidence = JSON.stringify({test:'pdp-20261015',arm,environment,journey});
    const indexes = [...data.keys()].map(key => key.match(/^items\[(\d+)\]\[id\]$/)?.[1]).filter(Boolean);
    if (indexes.length) indexes.forEach(index => { data.set(`items[${index}][properties][_FP PDP test]`,evidence); data.set(`items[${index}][properties][_FP PDP arm]`,arm); });
    else { data.set('properties[_FP PDP test]',evidence); data.set('properties[_FP PDP arm]',arm); }
    if (arm === 'control' && selector) {
      const selection = selector.currentSelection();
      submitted = ['bungee','collar'].filter(accessory => selection[accessory] && selector.addonChecked(accessory));
      indexes.forEach(index => {
        const id = data.get(`items[${index}][id]`);
        const role = String(id) === String(selection.main?.id) ? 'harness' : submitted.find(accessory => String(selection[accessory]?.id) === String(id));
        if (!role) return;
        data.set(`items[${index}][properties][_FP upsell]`,JSON.stringify({build:'upsell-v2',environment,journey,role,
          viewed:['bungee','collar'].filter(accessory => stages[accessory]?.viewed),details:['bungee','collar'].filter(accessory => stages[accessory]?.details),
          sources:Object.fromEntries(submitted.map(accessory => [accessory,'card']))}));
      });
    }
  });
  scope.querySelector('[data-package-gift-details]')?.addEventListener('toggle', event => {
    window.FourPawAnalytics?.publish('fourpaw:offer_details_toggled',{open:event.currentTarget.open});
  });
})();
